<template>
  <div class="user-details-anchors">
    <template v-if="userDetails.isNotEmptyAnchors">
      <div class="user-details-anchors__section app-key-value__row">
        <a-collapse expand-icon-position="right">
          <a-collapse-panel
            key="user-details-anchors.key-anchors"
            :header="'user-details-anchors.key-anchors' | globalize">
            <details-reader
              :with-accordion="true"
              :details="userDetails.anchors" />
          </a-collapse-panel>
        </a-collapse>
      </div>
    </template>
  </div>
</template>

<script>
import { UserRecord } from '@/js/records/entities/user.record'
import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import 'ant-design-vue/lib/collapse/style/index.css'

export default {
  name: 'user-details-anchors',
  components: {
    DetailsReader,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
  },
  props: {
    userDetails: {
      type: UserRecord,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.user-details-anchors__subtitle {
  margin-bottom: 2rem;
}

.user-details-anchors__section {
  margin-top: 3rem;
}

.user-details-anchors__section .ant-collapse-content-box {
  font: inherit;
  color: inherit;
}

.user-details-anchors__dropdown-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.user-details-anchors__dropdown-btn-icon {
  display: block;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  transition: all 0.3s;
}

</style>
